// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card__text{white-space:pre-wrap}.v-btn__content{width:100%;white-space:normal}", ""]);
// Exports
module.exports = exports;
